"use client";
import { useState } from "react";

interface BlogImageProps {
  src: string;
  alt: string;
  className?: string;
  style?: React.CSSProperties;
}

export default function BlogImage({ src, alt, className = '', style }: BlogImageProps) {
  const placeholder = "/blog-images/placeholder-image.png";
  const [imgSrc, setImgSrc] = useState(src);
  return (
    <img
      src={imgSrc}
      alt={alt}
      className={className}
      style={style}
      loading="lazy"
      onError={() => {
        if (imgSrc !== placeholder) setImgSrc(placeholder);
      }}
    />
  );
}
